<template>
  <ZtList v-if="courseTabDetails.showType === 4" />
  <Webview v-else-if="courseTabDetails.showType === 7" :courseTabDetails="courseTabDetails" />
  <div v-else class="courseCard">
    <Banner :bannerList="bannerList" v-show="bannerList.length" />
    <Advertisement v-show="advertisement.id" :advertisement="advertisement" />
    <HomeAdvert v-show="advertLists.length" :advertLists="advertLists" />
    <div
      class="middleTab courseCardMiddleTab"
      v-if="courseTabDetails.recommend && courseTabDetails.recommend.length > 0"
    >
      <ul class="middleTabUl">
        <li
          id="middleTabLi"
          :class="currentIndex === index ? 'middleTabActived' : 'middleTabUnActived'"
          v-for="(item, index) in courseTabDetails.recommend"
          :key="item.name"
          @click="middleTabLi(index, item.name)"
        >
          <p class="middleTabName">{{ item.name }}</p>
          <img
            src="@/assets/img/components/home/tabIcon.png"
            alt
            class="tabIcon"
            v-show="currentIndex === index ? true : false"
          />
        </li>
      </ul>
    </div>
    <ProductList :recomendId="recomendId" />
  </div>
</template>

<script>
import {  reqAdvertPlaying } from '@/api/home';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Advertisement from './advertisement.vue';
import HomeAdvert from './homeAdvert.vue';
import ZtList from './ztList.vue';
import Banner from './bannerVant.vue';
import Webview from './webview.vue';
import ProductList from './productList.vue';

export default {
  inheritAttrs: false,
  components: {
    ZtList,
    EmptyData,
    Banner,
    Advertisement,
    HomeAdvert,
    Webview,
    ProductList,
  },
  props: {
    remarkInfoList: {
      type: Array,
      default: () => [],
    },
    selectedSubNav: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    selectedSubNav: {
      immediate: true,
      deep: true,
      handler() {
        this.getCurrentInfo();
      },
    },
  },
  data() {
    return {
      currentIndex: 0,
      courseTabDetails: {},
      bannerList: [],
      advertLists: [], // 胶囊区
      advertisement: {}, // 长图广告位
      recomendId: '',
    };
  },
  methods: {
    getCurrentInfo() {
      const res = this.remarkInfoList.find((item, i) => i === this.selectedSubNav);
      console.log(res, 667);
      this.courseTabDetails = res||{};
      const { bannerCode, capsuleOneCode, capsuleTwoCode } = res||{};
      this.getAd(bannerCode).then((data) => {
        this.bannerList = data || [];
      });
      this.getAd(capsuleOneCode).then((data) => {
        this.advertisement = data?.[0] || {};
      });
      this.getAd(capsuleTwoCode).then((data) => {
        this.advertLists = data || [];
      });
      this.reqRecomedCourse();
    },
    // 请求广告位
    async getAd(adCode) {
      if (!adCode) return;
      const res = await reqAdvertPlaying([adCode]);
      const findRes = res.data?.find(
        (item) => item.adCode === adCode,
      )?.advertisingContentWebInfoRespVOS;
      return findRes;
    },
    middleTabLi(index, title) {
      this.currentIndex = index;
      this.reqRecomedCourse();
      gio('evar.set', 'courseList_evar', title);
    },
    reqRecomedCourse() {
      const { recommend, recommendId } = this.courseTabDetails;
      if (recommend) {
        const idx = this.currentIndex;
        const { recommendId } = recommend?.[idx];
        this.recomendId = recommendId;
      } else if (recommendId) {
        this.recomendId = recommendId;
      }
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.courseCard {
  padding: 0 40px;
  ::v-deep .banner {
    padding: 0;
  }
  ::v-deep .pxindBox {
    padding: 16px 0;
  }
  ::v-deep .advertisement {
    margin-bottom: 20px;
    padding: 0;
  }
}
.middleTab {
  padding: 0 0 20px 0;
  .middleTabUl {
    display: flex;
    flex-wrap: wrap;

    #middleTabLi {
      position: relative;
      width: 155px;
      height: 54px;
      margin: 0 12px 18px 0;
      line-height: 54px;
      text-align: center;
      border-radius: 7px;
      .middleTabName {
        padding-left: 10px;
        overflow: hidden;
        font-weight: 400;
        font-size: 25px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tabIcon {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 36px;
        height: 36px;
      }
    }
    #middleTabLi:nth-child(4n) {
      margin-right: 0;
    }
    .middleTabUnActived {
      color: #333;
      background: rgba(132, 132, 132, 0.1);
      border: 2px solid #eaeaea;
    }
    .middleTabActived {
      color: #ff6c02;
      background: rgb(254, 240, 231);
      border: 2px solid #ff6c02;
    }
  }
}
.hotCourse {
  min-height: 800px;
}

.nullCourse {
  ::v-deep .emptyIndent {
    height: 500px;
    padding-top: 40px;
    .product {
      display: none;
    }
  }
}

::v-deep .van-skeleton {
  margin-top: 10px;
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 6px;
}
::v-deep .van-loading {
  margin: 40px 0;
  text-align: center;
}
</style>
